import { useCallback, useRef, useState } from 'react'
import type { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'

export const DEFAULT_ROOMS: Array<App.Occupants> = [{ adults: 2, children: 0, infants: 0 }]

export function isDefaultOccupancy(rooms: Array<App.Occupants>): boolean {
  if (rooms.length !== DEFAULT_ROOMS.length) return false
  return rooms.every((room, i) => {
    const def = DEFAULT_ROOMS[i]
    return (
      room.adults === def.adults &&
      (room.children ?? 0) === (def.children ?? 0) &&
      (room.infants ?? 0) === (def.infants ?? 0) &&
      (!room.childrenAge || room.childrenAge.length === 0)
    )
  })
}

export default function useCarouselOccupancyFilter() {
  const [rooms, setRooms] = useState<Array<App.Occupants>>(DEFAULT_ROOMS)
  const [pendingRooms, setPendingRooms] = useState<Array<App.Occupants>>(DEFAULT_ROOMS)
  const [open, setOpen] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)

  const handleToggle = useCallback(() => {
    if (!open) {
      setPendingRooms(rooms)
    }
    setOpen(prev => !prev)
  }, [open, rooms])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const handlePendingChange = useCallback((nextRooms: Array<App.Occupants | App.RoomOccupants | OfferPageRoom>) => {
    setPendingRooms(nextRooms.map(({ adults, children, childrenAge, infants }) => ({
      adults,
      children,
      childrenAge,
      infants,
    })))
  }, [])

  const handleApply = useCallback(() => {
    setRooms(pendingRooms)
    setOpen(false)
  }, [pendingRooms])

  const clear = useCallback(() => {
    setRooms(DEFAULT_ROOMS)
  }, [])

  return {
    rooms,
    pendingRooms,
    open,
    triggerRef,
    handleToggle,
    handleClose,
    handlePendingChange,
    handleApply,
    clear,
  }
}
